<template>
  <v-col class="pt-0 mt-0">
    <v-tabs
      center-active
      class="d-print-none mb-5 mt-0"
      show-arrows
    >
      <v-tab :to="{ name: 'SalesReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Sales
      </v-tab>
      <v-tab :to="{ name: 'PurchaseOrdersReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Purchases
      </v-tab>
      <v-tab :to="{ name: 'RefundsReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Refunds
      </v-tab>
      <v-tab :to="{ name: 'PaymentReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Payments
      </v-tab>
      <v-tab :to="{ name: 'TaxReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Tax
      </v-tab>
      <v-tab :to="{ name: 'TopProductsReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Top Products
      </v-tab>

      <v-tab :to="{ name: 'PendingPaymentsReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Pending bills
      </v-tab>
      <v-tab :to="{ name: 'OverallStockCountsReport' }">
        <v-icon left>
          mdi-note-outline
        </v-icon>
        Overall Stock Counts
      </v-tab>
    </v-tabs>
    <router-view />
  </v-col>
</template>
<script>
export default {};
</script>
